import { NOT_FOUND } from 'redux-first-router';

const components = {
  HOME: 'Lander/Homepage',
  LANDER: 'Lander',
  SUBLANDER: 'Lander',
  ARTICLE: 'Article/Article',
  ARTICLE_DRAFT: 'Article/Article',
  ARTICLE_ROSTER: 'Article/Article',
  AUTHOR_BIO: 'Author',
  CONTACT: 'global/corporate/Contact',
  SEARCH: 'Search',
  PRIVACY: 'Privacy',
  PRIVACY_POLICY: 'global/legal/PrivacyPolicy',
  TERMS: 'global/legal/Terms',
  COMMERCE_POLICY: 'Page/CommercePolicyPage',
  ABOUT_US: 'Page/AboutUs/AboutUsPage',
  WOWSHOP: 'Page/WowShop/WowShopPage',
  PAGE: 'Page/PageGeneric/PageGeneric',
  EDITORIAL_POLICY: 'global/legal/EditorialPolicy',
  CONTEST_RULES: 'global/legal/ContestRules',
  [NOT_FOUND]: 'NotFound',
};

export default (state = 'HOME', action = {}) => components[action.type] || state;

// NOTES: this is the primary reducer demonstrating how RFR replaces the need
// for React Router's <Route /> component.
//
// ALSO:  Forget a switch, use a hash table for perf.
